const textData = [
  {
    no: 1,
    question:
      "バイクで出かける前に必ずしておきたい車両の点検。最低限、どの項目をチェックしておく必要があるでしょうか？",
    choices: [
      {
        index: "A",
        text: "ブレーキ、タイヤ、灯火類、燃料",
        correct: true,
      },
      {
        index: "B",
        text: "ブレーキ、燃料、メーター",
        correct: false,
      },
      {
        index: "C",
        text: "動けば問題はない",
        correct: false,
      },
    ],
    answer:
      "バイクの使用者は適切な時期に日常点検を行う必要がありますが、たくさんのパーツがあるバイクのどこから点検したらいいかわからない、という人も多いはず。そこで覚えておきたいのが「ブタと燃料」というキーワード。「ブ」はブレーキ、「タ」はタイヤ、「と」は灯火類、「燃料」はガソリンで、これらは不具合が事故につながる恐れのある大事なところです。最低限、出発前にここはチェ ックしておきましょう！",
  },
  {
    no: 2,
    question:
      "荷物をロープやネットを使ってリアシートに乗せていきたい時、どのような点に注意したらいいでしょう？",
    choices: [
      {
        index: "A",
        text: "前後のどこか2か所以上で固定する",
        correct: false,
      },
      {
        index: "B",
        text: "最低でも前後4か所以上で固定する",
        correct: true,
      },
      {
        index: "C",
        text: "きつめに縛れば大丈夫",
        correct: false,
      },
    ],
    answer:
      "道路上の落し物は落とし主の責任。事故や渋滞の原因とならないよう、何より大事な荷物をなくさないよう、固定はしっかり行いましょう！ 基本は車体の前後 2 か所づつ、合計 4 か所にロープやフックを通して、荷物がズレないよう固定します。固定したあとは、軽く荷物をゆすってズレないか、もう一度確認しておくのがベストです。",
  },
  {
    no: 3,
    question:
      "バイクに乗る際に着るウェア、どんな色のものを選んだ方がいいでしょう？",
    choices: [
      {
        index: "A",
        text: "なるべく明るい、目立つ色",
        correct: true,
      },
      {
        index: "B",
        text: "好きなものを着ればいい",
        correct: false,
      },
      {
        index: "C",
        text: "なるべく暗い、控えめな色",
        correct: false,
      },
    ],
    answer:
      "四輪車に比べて車体が小さいバイクは、四輪車のドライバーから見ると、ひょんなことから見落としやすい存在。バイクに乗るときは、なるべく見分けやすい、目立つ色のウェアを着ると、まわりのドライバーやライダーに自分の存在をアピールできるので安心です。もちろん、運転を妨げない、動きやすいウェアを選ぶのが一番ですよ！",
  },
  {
    no: 4,
    question:
      "バイクに乗る際に着けておきたいプロテクター。体のどこに着けたらいいでしょうか？",
    choices: [
      {
        index: "A",
        text: "肩、ひじ、わき腹",
        correct: false,
      },
      {
        index: "B",
        text: "肩、ひじ、胸、尻",
        correct: false,
      },
      {
        index: "C",
        text: "肩、ひじ、胸、脊椎",
        correct: true,
      },
    ],
    answer:
      "万一の転倒や事故の際に身体を守ってくれるプロテクター。バイクに乗る際には、しっかりプロテクターを装備しておくことが大切です。事故の際に深刻なダメージを受けることのないよう、肩やひじの関節部位、胸部、脊椎、可能ならひざやすねにもプロテクターを装備しておきましょう。もちろんヘルメットをしっかりかぶることも忘れずに！",
  },
  {
    no: 5,
    question:
      "出かけた先でバイクを停めておく際に便利なバイク専用駐車場。利用するときに大切なことはどれでしょうか？",
    choices: [
      {
        index: "A",
        text: "停められればどこでも自由",
        correct: false,
      },
      {
        index: "B",
        text: "枠内に停めしっかりロックする",
        correct: true,
      },
      {
        index: "C",
        text: "枠からはみ出ても固定が優先",
        correct: false,
      },
    ],
    answer:
      "日本のバイク駐車場はまだまだ足りない状況ですが、駐車場をもっと増やすためにも、マナーを守って、積極的に利用しましょう！ 利用時に大切なのは、他のバイクの迷惑にならないよう、駐車の際はしっかり枠内にバイクを停め、備え付けのチェーンロックがある場合はしっかりロックをすること。料金をきちんと支払うことと、場内では速やかにエンジンを切る心がけもお忘れなく！",
  },
  {
    no: 6,
    question:
      "友達とのツーリングなどの際、ETCを使わない場合有料道路の料金所で心がけたいことはどれでしょう？",
    choices: [
      {
        index: "A",
        text: "先頭のバイクがまとめて支払う",
        correct: true,
      },
      {
        index: "B",
        text: "ひとりひとりが個別に支払う",
        correct: false,
      },
      {
        index: "C",
        text: "お釣りのないように心がける",
        correct: false,
      },
    ],
    answer:
      "ツーリングなどで、お友達と複数のバイクで料金所を通るときは、先頭のライダ ーがまとめて料金を支払うと、長時間の停車を避けられるので、後続の渋滞の防止にもなってスマートです。支払いを済ませたら、安全のためにも、精算はその場でしないで、次の休憩地点や駐車場で行うようにしましょう。",
  },
  {
    no: 7,
    question:
      "四輪車の後ろについて走るとき、どのようなことに注意しておくとよいでしょうか？",
    choices: [
      {
        index: "A",
        text: "なるべく近づいて存在をアピール",
        correct: false,
      },
      {
        index: "B",
        text: "邪魔にならないよう道の端を走る",
        correct: false,
      },
      {
        index: "C",
        text: "四輪車から見やすい位置を走る",
        correct: true,
      },
    ],
    answer:
      "四輪車は意外と死角の多い乗り物。こちら側からはしっかり見えていても、実はバイクが死角に入っていて、向こうからは見えていない、ということもままあるのです。交通状況にもよりますが、周囲のドライバーにしっかり視認してもらえるよう、走行するときには前車との車間距離を十分に確保することが重要です。",
  },
  {
    no: 8,
    question:
      "高速道路や幹線道路での車線合流の際、どのように合流するのがスマートでしょうか？",
    choices: [
      {
        index: "A",
        text: "できるだけ早く合流する",
        correct: false,
      },
      {
        index: "B",
        text: "十分に加速して車線の先で合流",
        correct: true,
      },
      {
        index: "C",
        text: "いったん停止してから合流",
        correct: false,
      },
    ],
    answer:
      "合流のときに一番大切なのは、交通の流れに乗ってスムーズに合流すること。車線がつながったらすぐに入ろうとしないで、十分加速したあと、本線車道を通行している車の妨げにならないように注意して合流する事が大切です。",
  },
  {
    no: 9,
    question:
      "停車していたバイクを発進させるときの動作で正しいのはどれでしょう？",
    choices: [
      {
        index: "A",
        text: "すぐに発進してなるべく飛ばす",
        correct: false,
      },
      {
        index: "B",
        text: "ミラーと目視で後方確認をする",
        correct: true,
      },
      {
        index: "C",
        text: "クラクションで周囲に注意させる",
        correct: false,
      },
    ],
    answer:
      "乗車するときにまず周囲を見て安全を確認、発進のときにはウインカーを出し、ミラーで後方を確認したあと、周囲と後方を実際に目で確認してからスタート、というのは教習所で習ったと思いますが、意外とこれを忘れている人も多いのではないでしょうか？ そんなに大変な動作ではないので、バイクに乗るときは必ずこの動作をするように習慣づけておきましょう！",
  },
  {
    no: 10,
    question:
      "高速道路のサービスエリアなどにあるバイク駐車スペース。停め方としてスマートなのはどれでしょう？",
    choices: [
      {
        index: "A",
        text: "出しやすいようにバックで駐車",
        correct: false,
      },
      {
        index: "B",
        text: "空いていればどう停めても自由",
        correct: false,
      },
      {
        index: "C",
        text: "他のバイクにそろえた向きで駐車",
        correct: true,
      },
    ],
    answer:
      "最近は二輪専用の駐車スペースを備えたサービスエリアも増えてうれしいですね！ 駐車するときは、枠内からはみ出ないように注意しながら、他のバイクと向きをそろえて停めるのがグッドマナーです。これは、ほとんどのバイクがサイドスタンドでの駐車なので、逆向きに停めてしまうと隣のバイクとのスペースが狭くなってしまうから。ゆずり合って気持ちよく利用しましょう！",
  },
  {
    no: 11,
    question:
      "バイクに乗る際に欠かせないヘルメット。あご紐の締め方はどれが正しいでしょうか？",
    choices: [
      {
        index: "A",
        text: "あごとあご紐の間に指1本が入る程度",
        correct: true,
      },
      {
        index: "B",
        text: "できるだけきつく締める",
        correct: false,
      },
      {
        index: "C",
        text: "安全であれば締めなくてOK",
        correct: false,
      },
    ],
    answer:
      "ヘルメットは命を守る大切なアイテム。正しいサイズのものをかぶるのが一番ですが、あごひもをしっかり締めることもわすれずに！ タイプによって、D リング、バックル、ラチェットなどがありますが、いずれもあご紐は、苦しくならず、指一本入る程度で、きちんと締めましょう。",
  },
  {
    no: 12,
    question:
      "バイクに乗る際に履くシューズ。選ぶ際、基準はどのようなものにするといいでしょうか？",
    choices: [
      {
        index: "A",
        text: "履きやすければなんでもOK",
        correct: false,
      },
      {
        index: "B",
        text: "普段履いているスニーカー",
        correct: false,
      },
      {
        index: "C",
        text: "くるぶしが隠れる高さのもの",
        correct: true,
      },
    ],
    answer:
      "ライディング専用のブーツに越したことはありませんが、公道でバイクに乗るのであれば、バイク用につくられたライディングシューズを履くのがベターです。重要なポイントは、転倒時などにダメージを受けやすい、足のくるぶしが保護されていること。スニーカーなどを代わりに履くときは、シフトやブレーキの操作がスムーズにできることも確認しておきましょう。",
  },
  {
    no: 13,
    question:
      "バイクに貼ってあるのをよく見かけるこのステッカー。これは一体何でしょうか？",
    choices: [
      {
        index: "A",
        text: "二輪車防犯登録ステッカー",
        correct: true,
      },
      {
        index: "B",
        text: "月極駐車場の駐車許可証",
        correct: false,
      },
      {
        index: "C",
        text: "会社の社員証",
        correct: false,
      },
    ],
    answer:
      "「二輪車防犯登録ステッカー」とは、バイクの盗難抑止と、万が一の盗難時の早期発見を実現するためのシステムです。このステッカーを貼ることで、車両データが警察庁の全国オンライン網に登録されるので、盗難抑止効果が期待できるのと、万一の盗難の際にも早期発見が可能になります！ 登録は全国の取り扱い販売店で可能です。",
    notes: "https://www.jmpsa.or.jp/entry/gbou/shoplist.html",
  },
  {
    no: 14,
    question:
      "早朝や深夜の住宅街からバイクで出かけるとき、どのようなことに気を付けておくとスマートでしょうか？",
    choices: [
      {
        index: "A",
        text: "エンジンを吹かして暖気する",
        correct: false,
      },
      {
        index: "B",
        text: "暗いのでハイビームにしておく",
        correct: false,
      },
      {
        index: "C",
        text: "ちょっと離れたところで始動する",
        correct: true,
      },
    ],
    answer:
      "マナーというのは思いやり。まわりの人に迷惑とならないように気を付けることが一番大切です。静かな住宅街からの出発であれば、なるべく騒音を出さないよう、不要な空吹かしや長時間の暖機運転は避けるのがマナーです。暖機運転をしたい場合は、エンジンをかけたらすぐにゆっくり発進させたり、バイクを押したりして、ちょっと離れた場所に出てから行う工夫があるとスマートですよ！",
  },
  {
    no: 15,
    question:
      "見通しの悪い交差点。特に停止線はないようですが、ここを通過するとき、どういうことに気をつけたらいいでしょうか？",
    choices: [
      {
        index: "A",
        text: "クラクションで注意をうながす",
        correct: false,
      },
      {
        index: "B",
        text: "一旦停止か徐行で安全を確認",
        correct: true,
      },
      {
        index: "C",
        text: "できるだけ早く通過する",
        correct: false,
      },
    ],
    answer:
      "安全に気を付けるのはマナーというより基本です。見通しの悪い交差点を通るときは、すぐに止まれる状態で、周囲の安全に気を付けながら通過しましょう。特にバイクの場合、まわりの歩行者や対向車からは実際の速度より遅く見える場合があるので、安全確認は入念にしておきたいですね。",
  },
  {
    no: 16,
    question:
      "ツーリングなどで長めにバイクに乗るとき、休憩はどのくらいのペースで取るといいでしょうか？",
    choices: [
      {
        index: "A",
        text: "疲れていなければ不要",
        correct: false,
      },
      {
        index: "B",
        text: "1日に2～3回",
        correct: false,
      },
      {
        index: "C",
        text: "1～2時間に1回",
        correct: true,
      },
    ],
    answer:
      "バイクに乗っていると気分が高まるので長く走っていたいものですが、疲労がたまらないようにするのと、パンクなどのダメージがないか定期的にチェックすることを考えて、休憩は 1～2 時間おきに取りましょう。お友達と話すのも楽しいですし、休憩がてら観光スポットや道の駅を探索するのも、ツーリングならではの楽しみですよ！",
  },
  {
    no: 17,
    question:
      "山道で前の四輪車が道を譲ってくれるようです。さて、この場合どうしますか？",
    choices: [
      {
        index: "A",
        text: "せっかくなので素早く追い越す",
        correct: false,
      },
      {
        index: "B",
        text: "対向車を確認して追い越す",
        correct: false,
      },
      {
        index: "C",
        text: "見通しのいい直線路で追い越す",
        correct: true,
      },
    ],
    answer:
      "前の車両が道を譲ってくれる場合でも、追い越しをするときは対向車や周囲の状況に十分注意しないといけません。写真の場合、見通しの悪いブラインドカーブですから、あわてて追い越さずにそのまま進んで、見通しのいい直線路に出たら、対向車がいないことを確認して追い越すようにしましょう。追い越す際は、軽く会釈をするなどお礼をするとスマートですよ。",
  },
  {
    no: 18,
    question:
      "バイクで走行中に大事な電話が！ さて、この場合どうすればいいでしょうか？",
    choices: [
      {
        index: "A",
        text: "すぐに停車して電話に出る",
        correct: false,
      },
      {
        index: "B",
        text: "安全な場所に停めてかけ直す",
        correct: true,
      },
      {
        index: "C",
        text: "大事な電話なのでその場で出る",
        correct: false,
      },
    ],
    answer:
      "スマートフォンはとっても便利。ナビとして使ったり、音楽を聴いたりと大活躍です。スマホマウントを装着しているバイクも多くなりましたが、2019 年 12 月の道路交通法改正で、スマートフォンの画面を注視したり、操作しながら運転したりする行為に対する罰則が強化されました。もちろん、バイクでも「ながら運転」は絶対ダメ。安全な場所で停車してから、余裕をもって対応しましょう！",
  },
  {
    no: 19,
    question:
      "バイク駐車場がないので、パーキングメーターにバイクを停めました。コレって正しいですか？",
    choices: [
      {
        index: "A",
        text: "正しい",
        correct: true,
      },
      {
        index: "B",
        text: "間違っている",
        correct: false,
      },
      {
        index: "C",
        text: "バイクは歩道でOK",
        correct: false,
      },
    ],
    answer:
      "どうしてもバイクを駐車する必要があるときは、路上駐車をしないで、空いているパーキングメーターやパーキングチケットを利用しましょう！ 基本的に車両の駐車スペースなので、実はバイクも利用可能なのです！ 利用にあたっては、ひと枠 1 台とし、メーターの場合は車両をセンサーが感知するよう停めること、チケットの場合はしっかり見えるところに貼ることに注意しましょう。",
  },
  {
    no: 20,
    question:
      "最近増えてきたセルフ式のガソリンスタンド。給油の際、バイクは給油機のどちら側に停めておくとスマートでしょう？",
    choices: [
      {
        index: "A",
        text: "左側",
        correct: false,
      },
      {
        index: "B",
        text: "右側",
        correct: true,
      },
      {
        index: "C",
        text: "どちらでもよい",
        correct: false,
      },
    ],
    answer:
      "ほとんどのバイクがサイドスタンドなので、停車時にバイクは左に傾きます。バイクを給油機の右側に停めれば、給油の際、給油口が手前に傾いているので給油しやすくて便利ですよ。給油の際は、静電気除去シートにしっかりタッチするのを忘れずに。給油後はすみやかにバイクを前に出して、次の人に給油スペースを空けてあげるとよりスマートです！",
  },
]

export default textData

export const textDataTest = [
  {
    no: 1,
    question:
      "１あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつて",
    choices: [
      {
        index: "A",
        text: "あいうえおかきくけこさしすせそ",
        correct: true,
      },
      {
        index: "B",
        text: "なにぬねのはひふへほまみむめもやいゆ",
        correct: false,
      },
      {
        index: "C",
        text: "らりるれろわいうえをあいうえおかきく",
        correct: false,
      },
    ],
    answer:
      "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえを",
  },
  {
    no: 2,
    question:
      "２あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつて",
    choices: [
      {
        index: "A",
        text: "あいうえおかきくけこさしすせそ",
        correct: true,
      },
      {
        index: "B",
        text: "なにぬねのはひふへほまみむめもやいゆ",
        correct: false,
      },
      {
        index: "C",
        text: "らりるれろわいうえをあいうえおかきく",
        correct: false,
      },
    ],
    answer:
      "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえを",
  },
  {
    no: 3,
    question:
      "３あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつて",
    choices: [
      {
        index: "A",
        text: "あいうえおかきくけこさしすせそ",
        correct: true,
      },
      {
        index: "B",
        text: "なにぬねのはひふへほまみむめもやいゆ",
        correct: false,
      },
      {
        index: "C",
        text: "らりるれろわいうえをあいうえおかきく",
        correct: false,
      },
    ],
    answer:
      "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえを",
  },
  {
    no: 4,
    question:
      "４あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつて",
    choices: [
      {
        index: "A",
        text: "あいうえおかきくけこさしすせそ",
        correct: true,
      },
      {
        index: "B",
        text: "なにぬねのはひふへほまみむめもやいゆ",
        correct: false,
      },
      {
        index: "C",
        text: "らりるれろわいうえをあいうえおかきく",
        correct: false,
      },
    ],
    answer:
      "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえを",
  },
  {
    no: 5,
    question:
      "５あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつて",
    choices: [
      {
        index: "A",
        text: "あいうえおかきくけこさしすせそ",
        correct: true,
      },
      {
        index: "B",
        text: "なにぬねのはひふへほまみむめもやいゆ",
        correct: false,
      },
      {
        index: "C",
        text: "らりるれろわいうえをあいうえおかきく",
        correct: false,
      },
    ],
    answer:
      "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえを",
  },
  {
    no: 6,
    question:
      "６あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつて",
    choices: [
      {
        index: "A",
        text: "あいうえおかきくけこさしすせそ",
        correct: true,
      },
      {
        index: "B",
        text: "なにぬねのはひふへほまみむめもやいゆ",
        correct: false,
      },
      {
        index: "C",
        text: "らりるれろわいうえをあいうえおかきく",
        correct: false,
      },
    ],
    answer:
      "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえを",
  },
  {
    no: 7,
    question:
      "７あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつて",
    choices: [
      {
        index: "A",
        text: "あいうえおかきくけこさしすせそ",
        correct: true,
      },
      {
        index: "B",
        text: "なにぬねのはひふへほまみむめもやいゆ",
        correct: false,
      },
      {
        index: "C",
        text: "らりるれろわいうえをあいうえおかきく",
        correct: false,
      },
    ],
    answer:
      "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえを",
  },
  {
    no: 8,
    question:
      "８あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつて",
    choices: [
      {
        index: "A",
        text: "あいうえおかきくけこさしすせそ",
        correct: true,
      },
      {
        index: "B",
        text: "なにぬねのはひふへほまみむめもやいゆ",
        correct: false,
      },
      {
        index: "C",
        text: "らりるれろわいうえをあいうえおかきく",
        correct: false,
      },
    ],
    answer:
      "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえを",
  },
  {
    no: 9,
    question:
      "９あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつて",
    choices: [
      {
        index: "A",
        text: "あいうえおかきくけこさしすせそ",
        correct: true,
      },
      {
        index: "B",
        text: "なにぬねのはひふへほまみむめもやいゆ",
        correct: false,
      },
      {
        index: "C",
        text: "らりるれろわいうえをあいうえおかきく",
        correct: false,
      },
    ],
    answer:
      "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえを",
  },
  {
    no: 10,
    question:
      "１０あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつて",
    choices: [
      {
        index: "A",
        text: "あいうえおかきくけこさしすせそ",
        correct: true,
      },
      {
        index: "B",
        text: "なにぬねのはひふへほまみむめもやいゆ",
        correct: false,
      },
      {
        index: "C",
        text: "らりるれろわいうえをあいうえおかきく",
        correct: false,
      },
    ],
    answer:
      "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえをあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえを",
  },
  {
    no: 11,
    question:
      "０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９０１２３４",
    choices: [
      {
        index: "A",
        text: "あいう",
        correct: true,
      },
      {
        index: "B",
        text: "かきく",
        correct: false,
      },
      {
        index: "C",
        text: "さしす",
        correct: false,
      },
    ],
    answer:
      "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえを",
  },
  {
    no: 12,
    question:
      "０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９０１２３４",
    choices: [
      {
        index: "A",
        text: "あいう",
        correct: true,
      },
      {
        index: "B",
        text: "かきく",
        correct: false,
      },
      {
        index: "C",
        text: "さしす",
        correct: false,
      },
    ],
    answer:
      "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえを",
  },
  {
    no: 13,
    question:
      "０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９０１２３４",
    choices: [
      {
        index: "A",
        text: "あいう",
        correct: true,
      },
      {
        index: "B",
        text: "かきく",
        correct: false,
      },
      {
        index: "C",
        text: "さしす",
        correct: false,
      },
    ],
    answer:
      "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえを",
  },
  {
    no: 14,
    question:
      "０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９０１２３４",
    choices: [
      {
        index: "A",
        text: "あいう",
        correct: true,
      },
      {
        index: "B",
        text: "かきく",
        correct: false,
      },
      {
        index: "C",
        text: "さしす",
        correct: false,
      },
    ],
    answer:
      "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえを",
  },
  {
    no: 15,
    question:
      "０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９０１２３４",
    choices: [
      {
        index: "A",
        text: "あいう",
        correct: true,
      },
      {
        index: "B",
        text: "かきく",
        correct: false,
      },
      {
        index: "C",
        text: "さしす",
        correct: false,
      },
    ],
    answer:
      "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえを",
  },
  {
    no: 16,
    question:
      "０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９０１２３４",
    choices: [
      {
        index: "A",
        text: "あいう",
        correct: true,
      },
      {
        index: "B",
        text: "かきく",
        correct: false,
      },
      {
        index: "C",
        text: "さしす",
        correct: false,
      },
    ],
    answer:
      "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえを",
  },
  {
    no: 17,
    question:
      "０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９０１２３４",
    choices: [
      {
        index: "A",
        text: "あいう",
        correct: true,
      },
      {
        index: "B",
        text: "かきく",
        correct: false,
      },
      {
        index: "C",
        text: "さしす",
        correct: false,
      },
    ],
    answer:
      "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえを",
  },
  {
    no: 18,
    question:
      "０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９０１２３４",
    choices: [
      {
        index: "A",
        text: "あいう",
        correct: true,
      },
      {
        index: "B",
        text: "かきく",
        correct: false,
      },
      {
        index: "C",
        text: "さしす",
        correct: false,
      },
    ],
    answer:
      "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえを",
  },
  {
    no: 19,
    question:
      "０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９０１２３４",
    choices: [
      {
        index: "A",
        text: "あいう",
        correct: true,
      },
      {
        index: "B",
        text: "かきく",
        correct: false,
      },
      {
        index: "C",
        text: "さしす",
        correct: false,
      },
    ],
    answer:
      "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえを",
  },
  {
    no: 20,
    question:
      "０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９０１２３４",
    choices: [
      {
        index: "A",
        text: "あいう",
        correct: true,
      },
      {
        index: "B",
        text: "かきく",
        correct: false,
      },
      {
        index: "C",
        text: "さしす",
        correct: false,
      },
    ],
    answer:
      "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやいゆえよらりるれろわいうえを",
  },
]
